import { KeyboardArrowRight } from '@campoint/odi-ui-icons';
import { Button, ButtonProps, HStack, Icon } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { routes } from '../../../../routes/routesConfig';

export const SupportButton: React.FC<ButtonProps> = (props) => {
  const [t] = useTranslation(['general']);
  const history = useHistory();

  return (
    <Button
      children={t('general:button.SupportKontaktieren')}
      onClick={() => history.push(routes.help.path)}
      {...props}
    />
  );
};

export const OnRejectedSupportButton: React.FC<
  ButtonProps & { text: string }
> = ({ text }, props) => {
  const history = useHistory();

  return (
    <HStack onClick={() => history.push(routes.help.path)}>
      <Button
        data-testid={'on-rejected-support-button'}
        color={'indigo.500'}
        cursor={'pointer'}
        whiteSpace={'pre-wrap'}
        textAlign={'left'}
        variant={'link'}
        flex={1}
        _hover={{ textDecoration: 'none' }}
        children={text}
        rightIcon={
          <Icon
            as={KeyboardArrowRight}
            boxSize={'icon.md'}
            color={'indigo.500'}
          />
        }
        {...props}
      />
    </HStack>
  );
};
